export function triggerFreeTextEnter(){
	if($('.showMoreSearchItems').length > 0 && $('.searchHouseItem').length !== 1){
		$('.showMoreSearchItems').children('a')[0].click();
	}else if($('.searchHouseItem').length === 1){
		$('.searchHouseItem').children('a')[0].click();
	}
}
